function resolveObject(value) {
  return value && typeof value === 'object' && !Array.isArray(value) ? value : {};
}

function resolveArray(value) {
  return Array.isArray(value) ? value : [];
}

function text(value) {
  return String(value ?? '').trim();
}

function artifactStatus(record = {}) {
  const status = text(record.status).toLowerCase();
  if (['stored', 'ready', 'completed'].includes(status)) {
    return 'completed';
  }
  if (['partial', 'missing_file', 'invalid_storage', 'not_configured'].includes(status)) {
    return 'partial';
  }
  if (['failed', 'error'].includes(status)) {
    return 'failed';
  }
  return 'completed';
}

function artifactIdentity(record = {}) {
  return [
    text(record.filename),
    text(record.output_target || record.outputTarget),
    text(record.artifact_id || record.artifactId),
  ].filter(Boolean).slice(0, 2).join(' · ');
}

function outputLine(record = {}) {
  const detail = artifactIdentity(record);
  return detail ? `[${artifactStatus(record)}] 输出产物 · ${detail}` : '';
}

export function buildDocumentAgentOutputProcessLines(projection = {}) {
  const source = resolveObject(projection);
  const storedArtifacts = resolveArray(source.stored_artifacts || source.storedArtifacts);
  const generatedArtifacts = resolveArray(source.generated_artifacts || source.generatedArtifacts);
  const artifacts = storedArtifacts.length > 0 ? storedArtifacts : generatedArtifacts;
  return artifacts
    .map(resolveObject)
    .map(outputLine)
    .filter(Boolean);
}
